import api from "./api";


class DashboardService {
  // Get full statistics
  async getFullStatistics() {
    try {
      const response = await api.get('/dashboard/statistics');
      return response.data;
    } catch (error) {
      console.error('Error fetching full statistics:', error);
      throw error;
    }
  }

  // Get order statistics only
  async getOrderStatistics() {
    try {
      const response = await api.get('/dashboard/statistics/orders');
      return response.data;
    } catch (error) {
      console.error('Error fetching order statistics:', error);
      throw error;
    }
  }

  // Get financial statistics only
  async getFinancialStatistics() {
    try {
      const response = await api.get('/dashboard/statistics/financial');
      return response.data;
    } catch (error) {
      console.error('Error fetching financial statistics:', error);
      throw error;
    }
  }

  // Get basic counts (employees, companies, users)
  async getBasicCounts() {
    try {
      const response = await api.get('/dashboard/statistics/counts');
      return response.data;
    } catch (error) {
      console.error('Error fetching basic counts:', error);
      throw error;
    }
  }

  // Get top 5 products this month
  async getTopProductsThisMonth() {
    try {
      const response = await api.get('/dashboard/statistics/top-products');
      return response.data;
    } catch (error) {
      console.error('Error fetching top products:', error);
      throw error;
    }
  }

  // Get upcoming deliveries
  async getUpcomingDeliveries(days = 7) {
    try {
      const response = await api.get(`/dashboard/upcoming-deliveries?days=${days}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching upcoming deliveries:', error);
      throw error;
    }
  }
}

const dashboardService = new DashboardService();

// Export individual methods for backward compatibility if needed
export const getDashboardStats = async () => {
  return dashboardService.getFullStatistics();
};

export const getDashboardOrders = async () => {
  return dashboardService.getOrderStatistics();
};

export const getDashboardEmployees = async () => {
  // This might need a separate endpoint if you have employee data
  await dashboardService.getBasicCounts();
  return []; // Return empty array for now
};

export const getRecentActivity = async () => {
  // This can use order statistics
  return dashboardService.getOrderStatistics();
};

export const autoAssignOrders = async () => {
  // This needs its own endpoint implementation
  return { success: false, error: 'Not implemented' };
};

// Export the main service as default
export default dashboardService;